import * as _ from 'lodash';

function isPrimitive(value): boolean {
    return (value !== Object(value));
}

export function toCustomCamelCaseKey(obj: any): any {
    if (isPrimitive(obj)) {
        return obj;
    }

    let newObj: {} | any[];
    let newKey: string;
    if (obj instanceof Array) {
        newObj = [];
        for (const e of obj) {
            const o = toCustomCamelCaseKey(e);
            (newObj as any[]).push(o);
        }
    } else if (obj instanceof Object) {
        newObj = {};
        for (const key in obj) {
            newKey = _.camelCase(key);
            if (obj[key] instanceof Object) {
                const o = toCustomCamelCaseKey(obj[key]);
                newObj[newKey] = o || {};
            } else {
                newObj[newKey] = (obj[key] !== undefined) ? obj[key] : [];
            }
        }
    }

    return newObj;

}

/**
 * Espera até que determinada condição seja atendida
 */
export function waitFor(conditionFunction: () => boolean): Promise<void> {
    const poll = (resolve: () => void) => {
        if (conditionFunction()) {
            resolve();
        } else {
            requestAnimationFrame(() => poll(resolve));
        }
    }
    return new Promise(poll);
}
